import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Event, EventsResponse } from '../../models';
import { EVENTS_API_URL } from '../../tokens';

@Injectable()
export class EventsService {
  private readonly baseUrl = inject(EVENTS_API_URL);
  private readonly httpClient = inject(HttpClient);

  public get featuredEvents$(): Observable<EventsResponse> {
    return this.httpClient
      .get<EventsResponse>(`${this.baseUrl}/events/featured`)
      .pipe(
        map(response => {
          response.events.forEach((event: Event) => {
            event.image = `${this.baseUrl}/events/image?sourceUrl=${encodeURIComponent(event.image)}`;
          });

          return response;
        })
      );
  }
}
